import { render, staticRenderFns, recyclableRender, components } from "./questions.vue?vue&type=template&id=60bf58a7&scoped=true&"
var renderjs
import script from "./questions.vue?vue&type=script&lang=js&"
export * from "./questions.vue?vue&type=script&lang=js&"
import style0 from "./questions.vue?vue&type=style&index=0&id=60bf58a7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../HBuilderX.3.8.4.20230531/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60bf58a7",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/tabBar/wearhouse/questions.vue"
export default component.exports